
import { clsx } from "clsx";

import { UserPicture } from "../../../User";
import { PersonalityData } from "../../model/types/personalityData";

import cls from "./Advisor.module.scss";

interface AdvisorProps {
  className?: string;
  data: PersonalityData;
  onClick: (id: number) => void;
  isSelected?: boolean;
  hideTag?: boolean;
  hideIntro?: boolean;
}

export const Advisor = (props: AdvisorProps) => {
  const { className, data, onClick, isSelected, hideTag = false, hideIntro = false } = props;

  return (
    <div
      className={clsx(cls.Advisor, { [cls.isSelected]: isSelected }, [className])}
      onClick={() => onClick(data.id)}
    >
      <UserPicture size={64} src={data.picture} />
      <div className={cls.Details}>
        <div className={cls.Name}>{data.firstName}</div>
        {!hideTag && !!data.tagline && <div className={cls.Header}>{data.tagline}</div>}
        {!hideIntro && !!data.introduction && <div className={cls.SubHeader}>{data.introduction}</div>}
      </div>
    </div>
  );
};
